import { atom } from 'jotai';

import {
  ResponseTarjetasTokenizadas,
  TarjetaTokenizada,
  TipoProductoTO,
} from '@/types/myAccount';
import { PaymentMethod, CardKey } from '@/utils';

type Installment = {
  quantity: number;
  totalAmount: number;
};

export type PinsAccountData = {
  pinsAvailable: number;
  accountMoney: number;
  isPremium: boolean;
  tokenizedCard?: TarjetaTokenizada;
  responseTokenizedCards?: ResponseTarjetasTokenizadas;
  loadingTokenized?: boolean;
  selectedProduct?: TipoProductoTO;
  selectedPaymentMethod?: PaymentMethod;
  selectedCard?: CardKey;
  moneyToWallet?: number;
  showPaymentModalMethod?: boolean;
  showModalWhatsPins: boolean;
  showInputsModalPins: boolean;
  showModalWallet?: boolean;
  showWalletLoadModal?: boolean;
  showModalTransferBalance?: boolean;
  showModalPayWithPMC?: boolean;
  showModalPayWithLP?: boolean;
  showModalPayWithBalance?: boolean;
  showModalPayInInstallments?: boolean;
  showModalPayInOneInstallment?: boolean;
  selectedInstallment?: Installment;
  statusTransaction?: {
    status: 'error' | 'success' | null;
    msg?: string;
  };
};

export const initialPinsAccountState = {
  pinsAvailable: 0,
  accountMoney: 0,
  isPremium: false,
  tokenizedCard: undefined,
  responseTokenizedCards: undefined,
  loadingTokenized: false,
  selectedProduct: undefined,
  showModalPayInOneInstallment: false,
  selectedCard: undefined,
  showModalWallet: false,
  moneyToWallet: undefined, // dinero a cargar saldo
  showModalWhatsPins: false, // modal de que son los pines
  showInputsModalPins: false, // modal de ingreso de pin
  showModalWhatIsBalance: false, // modal que saldo
  showWalletLoadModal: false, // modal de carga de saldo
  showModalTransferBalance: false, // modal transferir saldo
  showModalPayWithPMC: false, // pago mis cuentas
  showModalPayWithLP: false, // pago link
  showPaymentModalMethod: false,
  selectedPaymentMethod: undefined,
  showModalPayWithBalance: false,
};

export const pinsAtom = atom<PinsAccountData>(initialPinsAccountState);
